export const fileUploadServerPath = "http://www.rhlm.co.za/upload";

//local
 export const QuotePdfUri = "http://www.rhlm.co.za/";
export const ResultsPdfUri = "http://www.rhlm.co.za/";
export const ResultsPdfPhysicalPath = "/home/hosting/documents";
export const serverPath = "http://www.rhlm.co.za/api"; 
export const messagePath = "http://www.rhlm.co.za/message/"; 
//server
/*
export const QuotePdfUri = "https://www.sure-quote.co.za/app/quotepdf/";
export const ResultsPdfUri = "https://www.sure-quote.co.za/resultpdf/";
export const ResultsPdfPhysicalPath = "C:\\Dev\\quote-history\\";
export const serverPath = "https://www.sure-quote.co.za:8080"
*/




// WEBPACK FOOTER //
// ./src/constants.js